import React from "react";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import suitcase from "../../../images/suitcase.svg";
import pic1 from "../../../images/comapny/icon_engineering.png";
import pic2 from "../../../images/comapny/icon_banking.png";
import pic3 from "../../../images/comapny/icon_gov.png";
import pic4 from "../../../images/comapny/icon_teaching.png";
import pic5 from "../../../images/comapny/icon_technology.png";
import pic6 from "../../../images/comapny/icon_railway.png";
import pic7 from "../../../images/comapny/icon_defence.png";
import pic8 from "../../../images/comapny/icon_gov.png";
import pic9 from "../../../images/comapny/icon_acc.png";
import pic10 from "../../../images/comapny/icon_gpsc.png";
import pic11 from "../../../images/comapny/icon_police.png";
import pic12 from "../../../images/comapny/icon_upsc.png";
import pic13 from "../../../images/comapny/icon_hr.png";
import pic14 from "../../../images/comapny/icon_sales.png";
import pic15 from "../../../images/comapny/icon_marketing.png";
import pic16 from "../../../images/comapny/icon_finance.png";
import pic17 from "../../../images/comapny/icon_operations.png";
import pic18 from "../../../images/comapny/icon_customer_service.png";
import pic19 from "../../../images/comapny/icon_embedded.png";
import pic20 from "../../../images/comapny/icon_ai_ml.png";

const categoryImages = {
  1: pic1,
  2: pic2,
  3: pic3,
  4: pic4,
  5: pic5,
  6: pic6,
  7: pic7,
  8: pic8,
  9: pic9,
  10: pic10,
  11: pic11,
  12: pic12,
  13: pic13,
  14: pic14,
  15: pic15,
  16: pic16,
  17: pic17,
  18: pic18,
  19: pic19,
  20: pic20,
};

const JobCard = ({ job }) => {
  const [imgError, setImgError] = useState(false);
  return (
    <div
      className="w-100 mb-3 p-2 p-sm-3"
      style={{ boxShadow: "0 0 2px 0px grey" }}
    >
      <div className="d-flex flex-column flex-sm-row align-items-center align-items-sm-start">
        <div className="me-sm-4 mb-3 mb-sm-0 h-60px w-60px">
          <div className="rounded-circle overflow-hidden d-flex justify-content-center align-items-center">
            <img
              src={categoryImages[job.job_category_id]}
              alt="Icon"
              style={{ height: 60, width: 60 }}
            />
          </div>
        </div>
        <div style={{ width: "100%" }}>
          <div className="mb-2">
            <div className="d-flex flex-column flex-sm-row w-100 justify-content-between align-items-center align-items-sm-start">
              <Link
                to={`/job-view/${job.job_id}`}
                target="_blank"
                rel="noopener noreferrer"
                className="fw-400 text-dark mb-2 mb-sm-1 text-center text-sm-start cursor-pointer"
                style={{ fontSize: 16 }}
              >
                {job.name}
              </Link>
              {job.is_closed == 1 && (
                <div
                  className="mt-1 mt-sm-0"
                  style={{
                    position: "relative",
                    padding: "2px 10px",
                    marginBottom: "0px",
                    border: "1px solid transparent",
                    borderRadius: "0.75rem",
                    color: "#721c24",
                    backgroundColor: "#f8d7da",
                    borderColor: "#f5c6cb",
                  }}
                >
                  <span
                    className="text-nowrap"
                    style={{ color: "#dc3545", fontSize: "14px" }}
                  >
                    Job Closed
                  </span>
                </div>
              )}
            </div>
          </div>
          <div
            className="d-flex flex-column flex-sm-row align-items-center justify-content-between"
            style={{ width: "100%" }}
          >
            <div className="d-flex flex-wrap mt-2 justify-content-center justify-content-sm-start">
              <div
                className="badge text-success mr-2 mb-2"
                style={{
                  backgroundColor: "#eefaf7",
                  fontSize: 14,
                  marginRight: "6px",
                  border: 1,
                  borderRight: "grey",
                }}
              >
                <img
                  loading="lazy"
                  src={suitcase}
                  alt=""
                  onError={() => setImgError(true)}
                  width={imgError ? "0" : "20"}
                  className="me-2"
                />
                {job.job_type}
              </div>
              <div
                className="border-right d-none d-sm-block"
                style={{
                  height: "28px",
                  borderRight: "1px solid #cccccc",
                  margin: "0 5px",
                }}
              ></div>
              <div
                style={{
                  backgroundColor: "#e9f6ff",
                  fontSize: 14,
                  marginLeft: "5px",
                }}
                className="badge text-primary mb-2"
              >
                {job.salary ?? "N/A"}
              </div>
            </div>

            <div className="mt-2 mt-sm-0">
              <Button
                as={Link}
                to={`/job-view/${job.job_id}`}
                size="sm"
                variant="primary"
                disabled={job.is_closed}
                className="w-100"
              >
                View Job
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobCard;
